import { action } from '@ember/object';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import SettingsPropertyTagsAutocompleteUser from 'lumen/components/settings/property-tags/autocomplete-user';
import type { PropertyTagsUser } from 'lumen/models';

interface SettingsPropertyTagsCellsTdSelectUserSignature {
  Args: {
    displayValue: {
      onEdit: (user: PropertyTagsUser | null) => void;
      subscriptionIds: string[];
      user: PropertyTagsUser | null;
    };
    row: {
      isDisabled?: boolean;
      isReadOnly?: boolean;
    };
  };
}

export default class SettingsPropertyTagsCellsTdSelectUser extends Component<SettingsPropertyTagsCellsTdSelectUserSignature> {
  @action selectUser(option: { user: PropertyTagsUser | null }): void {
    this.args.displayValue.onEdit(option.user);
  }

  <template>
    <div class="w-full" data-test-id="td-select-user">
      {{#if @row.isReadOnly}}
        {{if @displayValue.user @displayValue.user.name (t "general.missing")}}
      {{else}}
        <SettingsPropertyTagsAutocompleteUser
          @isDisabled={{@row.isDisabled}}
          @selectItem={{this.selectUser}}
          @subscriptionIds={{@displayValue.subscriptionIds}}
          @user={{@displayValue.user}}
        />
      {{/if}}
    </div>
  </template>
}
